import EditBrokerModal from './modals/EditBrokerModal';
import DraftBrokerTable from './tables/DraftBrokerTable';
import SentBrokerTable from './tables/SentBrokerTable';
import PendingBrokerTable from './tables/PendingBrokerTable';
import ActiveBrokerTable from './tables/ActiveBrokerTable';
import RejectedBrokerTable from './tables/RejectedBrokerTable';
import { SectionHeader } from '../common/SharedComponents';
import store, { brokerActions, searchActions } from '@apply/adminStore';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

function BrokerSummary() {
    const searchState = useSelector((state) => state.searchState);
    const { dispatch } = store;

    const _handleAddBroker = () => {
        dispatch(brokerActions.setBrokerId({ brokerId: null }));
        dispatch(brokerActions.setBrokerModalOpen({ openBrokerModal: true }));
    };

    const _onSearchChange = (event) => {
        dispatch(
            searchActions.setSearchText({
                searchText: {
                    ...searchState.searchText,
                    broker: event.target.value,
                },
            })
        );
    };

    return (
        <>
            <SectionHeader
                title='Brokers'
                buttonText='Add Broker'
                buttonCallback={_handleAddBroker}
            />
            <div
                className='main-content'
                style={{ padding: 0, backgroundColor: '#f4f4f4' }}
            >
                <div className='input-has-icon main-search'>
                    <input
                        type='search'
                        placeholder='Search to Filter Brokers'
                        value={searchState.searchText?.broker}
                        onChange={_onSearchChange}
                    />
                    <FontAwesomeIcon
                        icon={faSearch}
                        aria-hidden='true'
                        className='icon'
                    />
                </div>
                <div className='scrollable-content'>
                    <div
                        className='accordion'
                        data-accordion=''
                        data-allow-all-closed='true'
                        data-multi-expand='true'
                    >
                        <DraftBrokerTable />
                        <SentBrokerTable />
                        <PendingBrokerTable />
                        <ActiveBrokerTable />
                        <RejectedBrokerTable />
                    </div>
                </div>
            </div>
            <EditBrokerModal />
        </>
    );
}

export default BrokerSummary;
